var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.modal.component)?_c(_vm.modal.component,_vm._g(_vm._b({ref:"modal",tag:"component",attrs:{"is-loading":_vm.loading}},'component',_vm.modal.props,false),_vm.modal.listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }